export const normalizeLinkText = (link: string): string => {
  return link.replace(/ /gi, '%20').replace(/(\r\n|\n|\r)/gi, '%0A');
};
